import config from './config';
//#endregion
//#region Functions
// merchant-api
// 1.0
// http://test5-bg-api-gateway.zhiketong.net[80]/merchant-api/swagger-ui.html
/**
 * 保存品牌数据及负责的员工,返回主键id，用于直连自动创建品牌
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminAddHotelBrand(body, header) {
    var url = "/merchant-api/admin/addHotelBrand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 品牌管理公司列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminBrandManagementCompanyList(body, header) {
    var url = "/merchant-api/admin/brandManagementCompanyList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除品牌管理公司数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminDeleteBrandManagementCompany(body, header) {
    var url = "/merchant-api/admin/deleteBrandManagementCompany";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据操作员ID集合查询对应名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminFindAdminByAdminIds(query, header) {
    var url = "/merchant-api/admin/findAdminByAdminIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据操作员ID集合查询对应名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminFindAdminInfoByAdminId(query, header) {
    var url = "/merchant-api/admin/findAdminInfoByAdminId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据操作员ID集合查询对应名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminFindAdminNameByAdminIds(query, header) {
    var url = "/merchant-api/admin/findAdminNameByAdminIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据操作员ID集合查询对应名称
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminFindAdminNameByAdminIdsByPost(body, header) {
    var url = "/merchant-api/admin/findAdminNameByAdminIdsByPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询品牌信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminFindHotelBrand(body, header) {
    var url = "/merchant-api/admin/findHotelBrand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取类型列表
 * @param header The http request header parameters.
 */
export function getAdminGetBrandTypeList(header) {
    var url = "/merchant-api/admin/get_brand_type_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 品牌列表
 * @param header The http request header parameters.
 */
export function getAdminHotelBrandList(header) {
    var url = "/merchant-api/admin/hotelBrandList";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 查询品牌名称及品牌管理公司名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminQueryHotelBrandNameAndCompanyName(query, header) {
    var url = "/merchant-api/admin/queryHotelBrandNameAndCompanyName";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存品牌管理公司数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminSaveBrandManagementCompany(body, header) {
    var url = "/merchant-api/admin/saveBrandManagementCompany";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存品牌数据及负责的员工
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postAdminSaveHotelBrand(body, header) {
    var url = "/merchant-api/admin/saveHotelBrand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 过滤brand下的酒店列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandFilterBrandHotels(query, header) {
    var url = "/merchant-api/brand/filter_brand_hotels";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询酒店基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandFindAllHotelListByBrandId(query, header) {
    var url = "/merchant-api/brand/findAllHotelListByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * brandId按关键字模糊搜索商户列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandFindFuzzyHotelInfoByBrandId(query, header) {
    var url = "/merchant-api/brand/findFuzzyHotelInfoByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 模糊搜索集团品牌列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandFuzzySearchHotelBrand(body, header) {
    var url = "/merchant-api/brand/fuzzy_search_hotel_brand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appId查询openId  或者 根据openId查询appId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetAppIdConfig(query, header) {
    var url = "/merchant-api/brand/getAppIdConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团名称模糊查询或集团Id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandByNameOrBrandId(query, header) {
    var url = "/merchant-api/brand/getBrandByNameOrBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId查询配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandConfigByAppId(query, header) {
    var url = "/merchant-api/brand/getBrandConfigByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据BrandId查询配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandConfigByBrandId(query, header) {
    var url = "/merchant-api/brand/getBrandConfigByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 搜索集团下酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandGetBrandHotels(body, header) {
    var url = "/merchant-api/brand/getBrandHotels";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appId or brandId查询酒店基础信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandGetBrandInfo(body, header) {
    var url = "/merchant-api/brand/getBrandInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询brandId与金房卡interId对应关系,参数至少传一个
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandInterIdMapping(query, header) {
    var url = "/merchant-api/brand/getBrandInterIdMapping";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询zktBrand与金房卡interId对应关系的全部数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandInterIdMappingAll(query, header) {
    var url = "/merchant-api/brand/getBrandInterIdMappingAll";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据BrandId批量查询金房卡interId对应关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandGetBrandInterIdMappingByBrandIds(body, header) {
    var url = "/merchant-api/brand/getBrandInterIdMappingByBrandIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据集团id列表查询集团列表，仅包含id和名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandListByBrandIds(query, header) {
    var url = "/merchant-api/brand/getBrandListByBrandIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询brand的金房卡迁移信息(包括interId和迁移时间)，只有实际迁移了才返回，否则返回null
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandMigrateInfo(query, header) {
    var url = "/merchant-api/brand/getBrandMigrateInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据主店ID查询集团简单信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandSimpleInfoByOwnByHotelId(query, header) {
    var url = "/merchant-api/brand/getBrandSimpleInfoByOwnByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询集团基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetEndBrandInfo(query, header) {
    var url = "/merchant-api/brand/getEndBrandInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brand_id查询hotel_id（只支持集团关系，不支持自营brandId）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetHotelByBrandId(query, header) {
    var url = "/merchant-api/brand/getHotelByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团Id查询上次授权错误
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetLastAuthorizeError(query, header) {
    var url = "/merchant-api/brand/getLastAuthorizeError";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团Id查询自营酒店Id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetSelfHotelIdByBrandIds(query, header) {
    var url = "/merchant-api/brand/getSelfHotelIdByBrandIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询主店基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetSelfHotelInfoByBrandId(query, header) {
    var url = "/merchant-api/brand/getSelfHotelInfoByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团Id查询自营酒店名称
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandGetSelfHotelNameByBrandIds(body, header) {
    var url = "/merchant-api/brand/getSelfHotelNameByBrandIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过集团id搜索开通AI酒店基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetAiHotelBaseInfoByBrandId(query, header) {
    var url = "/merchant-api/brand/get_ai_hotel_base_info_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的所有集团关系，自营和集团（支持多种模式）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetAllHotelBaseInfoAndRelation(query, header) {
    var url = "/merchant-api/brand/get_all_hotel_base_info_and_relation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过集团id所有酒店所在城市（省市联动，海外城市）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetAreasByBrandId(query, header) {
    var url = "/merchant-api/brand/get_areas_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 搜索集团下酒店id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandHotelIds(query, header) {
    var url = "/merchant-api/brand/get_brand_hotel_ids";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询集团下的品牌/标签/设施字典
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandLabelFacilityDictionary(query, header) {
    var url = "/merchant-api/brand/get_brand_label_facility_dictionary";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询所属品牌集团的主店,其它情况null
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetBrandOwnerByHotelId(query, header) {
    var url = "/merchant-api/brand/get_brand_owner_by_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的所有集团关系，自营和集团
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetHotelAllBrandRelation(query, header) {
    var url = "/merchant-api/brand/get_hotel_all_brand_relation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过集团id搜索所绑定的酒店基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetHotelBaseInfoByBrandId(query, header) {
    var url = "/merchant-api/brand/get_hotel_base_info_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过关键词搜索集团下的酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetHotelByBrandKeyword(query, header) {
    var url = "/merchant-api/brand/get_hotel_by_brand_keyword";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过集团id搜索所绑定的酒店基础信息以及管理信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetHotelManageInfoByBrandId(query, header) {
    var url = "/merchant-api/brand/get_hotel_manage_info_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appid获取集团模式及迁移app信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBrandGetMigratingInfoByAppid(query, header) {
    var url = "/merchant-api/brand/get_migrating_info/by_appid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步金房卡商户迁移数据
 * @param header The http request header parameters.
 */
export function getBrandGoldenRoomCardProcessTask(header) {
    var url = "/merchant-api/brand/goldenRoomCardProcessTask";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 通知金房卡开始迁移并在做endBrand标记
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandMigrateStart(body, header) {
    var url = "/merchant-api/brand/migrateStart";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过集团id所有酒店所在城市（省市联动，海外城市）支持指定酒店列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandQueryAreasByBrandId(body, header) {
    var url = "/merchant-api/brand/query_areas_by_brand_id";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过关键词搜索集团下的酒店,支持指定酒店列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandQueryHotelByBrandKeyword(body, header) {
    var url = "/merchant-api/brand/query_hotel_by_brand_keyword";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过条件搜索集团下酒店列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBrandSearchHotelListByCondition(body, header) {
    var url = "/merchant-api/brand/search_hotel_list_by_condition";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * u
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postBrandU(query, header) {
    var url = "/merchant-api/brand/u";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 查询业务线单个配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getBusinessConfigGetBusinessConfig(query, header) {
    var url = "/merchant-api/businessConfig/getBusinessConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除业务线单个配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBusinessConfigRemoveBusinessConfig(body, header) {
    var url = "/merchant-api/businessConfig/removeBusinessConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存业务线单个配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postBusinessConfigSetBusinessConfig(body, header) {
    var url = "/merchant-api/businessConfig/setBusinessConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取商户会员配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMemberConfigGetMemberConfig(query, header) {
    var url = "/merchant-api/c/member_config/get_member_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取商户会员配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCMemberConfigGetMemberConfigList(body, header) {
    var url = "/merchant-api/c/member_config/get_member_config_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量保存中央预订商户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCentralBookBatchSaveMerchantBookCenter(body, header) {
    var url = "/merchant-api/central_book/batch_save_merchant_book_center";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 关闭中央预订商户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCentralBookCloseMerchantBookCenter(query, header) {
    var url = "/merchant-api/central_book/close_merchant_book_center";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 中央预订获取集团下所有店菜单
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCentralBookGetBrandHotelMenu(query, header) {
    var url = "/merchant-api/central_book/get_brand_hotel_menu";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 中央预订商户版推广开关配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCentralBookShanghuChannel(body, header) {
    var url = "/merchant-api/central_book/shanghu_channel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 中央预订商户版推广渠道配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCentralBookShanghuPromotionChannelConfig(body, header) {
    var url = "/merchant-api/central_book/shanghu_promotion_channel_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 中央预订商户版推广开关配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCentralBookStaffPromotionConfig(body, header) {
    var url = "/merchant-api/central_book/staff_promotion_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 关闭渠道
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCloseChannel(body, header) {
    var url = "/merchant-api/closeChannel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量修改酒店配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigBatchUpdateHotelListConfig(body, header) {
    var url = "/merchant-api/config/batchUpdateHotelListConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 单商户多配置修改
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigBatchHotelConfig(body, header) {
    var url = "/merchant-api/config/batch_hotel_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 按brandId获得商户的配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigBrandHasConfig(query, header) {
    var url = "/merchant-api/config/brandHasConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按brandId批量获得商户的配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigBrandHasConfigs(body, header) {
    var url = "/merchant-api/config/brandHasConfigs";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 按brandId主店获得商户的配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigBrandOwnHotelHasConfig(query, header) {
    var url = "/merchant-api/config/brandOwnHotelHasConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 一键切换小程序配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigChangeAppletPromotionConfig(query, header) {
    var url = "/merchant-api/config/change_applet_promotion_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigDeleteHotelConfigItem(body, header) {
    var url = "/merchant-api/config/deleteHotelConfigItem";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获得所有的配置项
 * @param header The http request header parameters.
 */
export function getConfigGetAllHotelConfigItems(header) {
    var url = "/merchant-api/config/getAllHotelConfigItems";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获得所有的会员中心掩码配置项
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetAllMerchantMaskItem(query, header) {
    var url = "/merchant-api/config/getAllMerchantMaskItem";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有开通订阅通知商户的brandId
 * @param header The http request header parameters.
 */
export function getConfigGetAllSubscribeToBrandId(header) {
    var url = "/merchant-api/config/getAllSubscribeToBrandId";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获得集团商户的单个配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandHotelConfig(query, header) {
    var url = "/merchant-api/config/getBrandHotelConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得一个集团下，多个商户的单个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetBrandHotelConfigs(body, header) {
    var url = "/merchant-api/config/getBrandHotelConfigs";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 按brandId主店获取商户所有配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandOwnHotelConfigAll(query, header) {
    var url = "/merchant-api/config/getBrandOwnHotelConfigAll";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按appId主店获取商户所有配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandOwnHotelConfigAllByAppId(query, header) {
    var url = "/merchant-api/config/getBrandOwnHotelConfigAllByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按brandId主店获取商户多个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetBrandOwnHotelConfigList(body, header) {
    var url = "/merchant-api/config/getBrandOwnHotelConfigList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 按appId主店获取商户多个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetBrandOwnHotelConfigListByAppId(body, header) {
    var url = "/merchant-api/config/getBrandOwnHotelConfigListByAppId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获得商户的单个配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfig(query, header) {
    var url = "/merchant-api/config/getHotelConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得商户的所有配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigAll(query, header) {
    var url = "/merchant-api/config/getHotelConfigAll";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据AppId查询自营店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigByAppId(query, header) {
    var url = "/merchant-api/config/getHotelConfigByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团ID查询自营店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigByBrandId(query, header) {
    var url = "/merchant-api/config/getHotelConfigByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得多个商户的单个配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigByHotelIds(query, header) {
    var url = "/merchant-api/config/getHotelConfigByHotelIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得单个配置项
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigItem(query, header) {
    var url = "/merchant-api/config/getHotelConfigItem";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得商户的多个配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigList(query, header) {
    var url = "/merchant-api/config/getHotelConfigList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得商户的多个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetHotelConfigListPost(body, header) {
    var url = "/merchant-api/config/getHotelConfigListPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取所有配置了key,value的商户id(默认配置不算)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelIdsByKeyAndValue(query, header) {
    var url = "/merchant-api/config/getHotelIdsByKeyAndValue";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得会员导入配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetMemberImportConfig(query, header) {
    var url = "/merchant-api/config/getMemberImportConfig";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得推广渠道
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetPromotionChannel(query, header) {
    var url = "/merchant-api/config/getPromotionChannel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户的订阅配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetSubscribeByHotelId(query, header) {
    var url = "/merchant-api/config/getSubscribeByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过corpOpenId获取商户易企秀配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandInfoByCropOpenId(query, header) {
    var url = "/merchant-api/config/get_brand_info_by_crop_open_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按brandId主店获取商户的配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandOwnHotelConfig(query, header) {
    var url = "/merchant-api/config/get_brand_own_hotel_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取集团主店配置通过酒店id查询
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetBrandOwnerHotelConfigByHotelId(query, header) {
    var url = "/merchant-api/config/get_brand_owner_hotel_config_by_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getCentralBookConfig
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetCentralBookConfig(query, header) {
    var url = "/merchant-api/config/get_central_book_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过appId查询集团中央预订配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetCentralBookConfigByAppId(query, header) {
    var url = "/merchant-api/config/get_central_book_config_by_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取中央预定模式下的自营brand
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetCentralBookSelfClient(query, header) {
    var url = "/merchant-api/config/get_central_book_self_client";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户易企秀密钥
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetEqxiuSecretKey(query, header) {
    var url = "/merchant-api/config/get_eqxiu_secret_key";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId获取指定配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelConfigByAppid(query, header) {
    var url = "/merchant-api/config/get_hotel_config_by_appid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得商户的多个配置项信息(AI查询使用)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetHotelConfigInfoList(body, header) {
    var url = "/merchant-api/config/get_hotel_config_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取商户互动游戏配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelEqxiuConfigInfo(query, header) {
    var url = "/merchant-api/config/get_hotel_eqxiu_config_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户产品推广配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelExtensionConfig(query, header) {
    var url = "/merchant-api/config/get_hotel_extension_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过hotelId获取使用的商户appId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetHotelShanghuAppidByHotelid(query, header) {
    var url = "/merchant-api/config/get_hotel_shanghu_appid_by_hotelid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过hotelId获取使用的商户appId
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigGetHotelShanghuAppidByHotelids(body, header) {
    var url = "/merchant-api/config/get_hotel_shanghu_appid_by_hotelids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appCode获取商户id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetMerchantIdByAppCode(query, header) {
    var url = "/merchant-api/config/get_merchant_id_by_app_code";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId获取商户pos机打印配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetMerchantPosPrintConfig(query, header) {
    var url = "/merchant-api/config/get_merchant_pos_print_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取视频号小店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigGetWechatStoreConfigByToUserName(query, header) {
    var url = "/merchant-api/config/get_wechat_store_config_by_to_user_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按hotelId批量获得商户的配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigHotelHasConfigByHotelIds(body, header) {
    var url = "/merchant-api/config/hotelHasConfigByHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过appid判断是否是商户版公众号
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigIsShanghuByAppid(query, header) {
    var url = "/merchant-api/config/is_shanghu_by_appid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户ID查询POI配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getConfigPoiSetting(query, header) {
    var url = "/merchant-api/config/poi_setting";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 恢复删除的配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigRecoverHotelConfigItem(body, header) {
    var url = "/merchant-api/config/recoverHotelConfigItem";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigSaveHotelConfigItem(body, header) {
    var url = "/merchant-api/config/saveHotelConfigItem";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存推广渠道
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigSavePromotionChannel(body, header) {
    var url = "/merchant-api/config/savePromotionChannel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存集团商户单个配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigSetBrandHotelConfig(body, header) {
    var url = "/merchant-api/config/setBrandHotelConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存商户单个配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigSetHotelConfig(body, header) {
    var url = "/merchant-api/config/setHotelConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置会员导入配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigSetMemberImportConfig(body, header) {
    var url = "/merchant-api/config/setMemberImportConfig";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改配置KEY
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postConfigUpdateItemKey(body, header) {
    var url = "/merchant-api/config/updateItemKey";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改易企秀配置的brand信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postConfigUpdateEqxiuBrand(query, header) {
    var url = "/merchant-api/config/update_eqxiu_brand";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 新增
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDictAdd(body, header) {
    var url = "/merchant-api/dict/add";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDictList(body, header) {
    var url = "/merchant-api/dict/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDictUpdate(body, header) {
    var url = "/merchant-api/dict/update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询分销酒店基本信息,最多500个酒店Id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDistributeHotelGetHotelInfoByHotelIdList(body, header) {
    var url = "/merchant-api/distribute/hotel/getHotelInfoByHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 绑定指定渠道分销关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDistributionSaleBindDistributionSaleRelation(body, header) {
    var url = "/merchant-api/distribution_sale/bindDistributionSaleRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更改小生活绑定状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDistributionSaleChangeLittleLifeSaleRelation(body, header) {
    var url = "/merchant-api/distribution_sale/change_little_life_sale_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置集团分销关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getDistributionSaleChangeSaleRelationByBrandId(query, header) {
    var url = "/merchant-api/distribution_sale/change_sale_relation_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 清理关系
 * @param header The http request header parameters.
 */
export function getDistributionSaleCleanSaleRelation(header) {
    var url = "/merchant-api/distribution_sale/clean_sale_relation";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取小生活分销集团id
 * @param header The http request header parameters.
 */
export function getDistributionSaleLittleLifeSaleBrandId(header) {
    var url = "/merchant-api/distribution_sale/little_life_sale_brand_id";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 解绑指定渠道的分销关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDistributionSaleUnbindDistributionSaleRelation(body, header) {
    var url = "/merchant-api/distribution_sale/unbindDistributionSaleRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据BrandId查询配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbBrandGetBrandConfigByBrandId(query, header) {
    var url = "/merchant-api/eb/brand/getBrandConfigByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询集团汇总信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbBrandGetBrandGroupInfo(query, header) {
    var url = "/merchant-api/eb/brand/getBrandGroupInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询集团下子店所在城市
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbBrandGetBrandHotelCitys(query, header) {
    var url = "/merchant-api/eb/brand/getBrandHotelCitys";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据BrandId查询hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbBrandGetHotelByBrandId(query, header) {
    var url = "/merchant-api/eb/brand/getHotelByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得所有的配置项
 * @param header The http request header parameters.
 */
export function getEbConfigGetAllHotelConfigItems(header) {
    var url = "/merchant-api/eb/config/getAllHotelConfigItems";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获得所有的掩码配置项
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetAllMerchantMaskItem(query, header) {
    var url = "/merchant-api/eb/config/getAllMerchantMaskItem";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按brandId主店获取商户多个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigGetBrandOwnHotelConfigList(body, header) {
    var url = "/merchant-api/eb/config/getBrandOwnHotelConfigList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 按appId主店获取商户多个配置值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigGetBrandOwnHotelConfigListByAppId(body, header) {
    var url = "/merchant-api/eb/config/getBrandOwnHotelConfigListByAppId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获得商户的所有配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetHotelConfigAll(query, header) {
    var url = "/merchant-api/eb/config/getHotelConfigAll";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得商户的多个配置项信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigGetHotelConfigInfoList(body, header) {
    var url = "/merchant-api/eb/config/getHotelConfigInfoList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取商户的订阅配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetSubscribe(query, header) {
    var url = "/merchant-api/eb/config/getSubscribe";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取中央预订配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetCentralBookConfig(query, header) {
    var url = "/merchant-api/eb/config/get_central_book_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户易企秀配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetHotelEqxiuConfigInfo(query, header) {
    var url = "/merchant-api/eb/config/get_hotel_eqxiu_config_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId获取商户pos机业务线打印配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetMerchantPosPrintConfig(query, header) {
    var url = "/merchant-api/eb/config/get_merchant_pos_print_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId获取商户pos机打印配置信息集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigGetMerchantPosPrintConfigList(query, header) {
    var url = "/merchant-api/eb/config/get_merchant_pos_print_config_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户pos机打印配置模版
 * @param header The http request header parameters.
 */
export function getEbConfigGetMerchantPosPrintConfigTemplate(header) {
    var url = "/merchant-api/eb/config/get_merchant_pos_print_config_template";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 初始化酒店配置缓存
 * @param header The http request header parameters.
 */
export function getEbConfigInitHotelConfigCache(header) {
    var url = "/merchant-api/eb/config/initHotelConfigCache";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 开启酒店推广渠道
 * @param header The http request header parameters.
 */
export function getEbConfigOpenHotelPromotionChannel(header) {
    var url = "/merchant-api/eb/config/openHotelPromotionChannel";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 查询商户kol配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbConfigQueryKolConfig(query, header) {
    var url = "/merchant-api/eb/config/query_kol_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量保存商户掩码配置项
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigSaveMerchantMaskItem(query, body, header) {
    var url = "/merchant-api/eb/config/saveMerchantMaskItem";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 保存商户订阅配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigSaveSubscribe(body, header) {
    var url = "/merchant-api/eb/config/saveSubscribe";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存商户pos机打印配置信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigSaveMerchantPosPrintConfig(body, header) {
    var url = "/merchant-api/eb/config/save_merchant_pos_print_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存商户单个配置项
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbConfigSetHotelConfig(query, body, header) {
    var url = "/merchant-api/eb/config/setHotelConfig";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 查询商户基本信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelBaseQuery(query, header) {
    var url = "/merchant-api/eb/hotel/base/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存商户基本信息
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelBaseSave(query, body, header) {
    var url = "/merchant-api/eb/hotel/base/save";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 酒店品牌分类列表排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelBrandCategoryListSort(body, header) {
    var url = "/merchant-api/eb/hotel/brand_category_list_sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 检查酒店品牌配置完成
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelCheckHotelBrandConfigCompleted(query, header) {
    var url = "/merchant-api/eb/hotel/check_hotel_brand_config_completed";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询商户上下文
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelCtxQuery(query, header) {
    var url = "/merchant-api/eb/hotel/ctx/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步商户标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelDcsSyncHotelTag(body, header) {
    var url = "/merchant-api/eb/hotel/dcs/sync_hotel_tag";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除品牌分类
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelDeleteBrandCategory(query, header) {
    var url = "/merchant-api/eb/hotel/delete_brand_category";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 根据userIds删除团建账户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelDeleteSecondBonusOwner(query, header) {
    var url = "/merchant-api/eb/hotel/delete_second_bonus_owner";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 根据主店ID查询集团简单信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetBrandInfoByOwnByHotelId(query, header) {
    var url = "/merchant-api/eb/hotel/getBrandInfoByOwnByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据配置获取全部商户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetConfigReportHotels(query, header) {
    var url = "/merchant-api/eb/hotel/getConfigReportHotels";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据办事处查询酒店数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetEndHotelsByOrgOfficeId(query, header) {
    var url = "/merchant-api/eb/hotel/getEndHotelsByOrgOfficeId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandID查询其下酒店的ID及名称(中文/英文/其他语言)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetHotelSimpleInfoListByBrandId(query, header) {
    var url = "/merchant-api/eb/hotel/getHotelSimpleInfoListByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店星级列表
 * @param header The http request header parameters.
 */
export function getEbHotelGetHotelStarAllInfo(header) {
    var url = "/merchant-api/eb/hotel/getHotelStarAllInfo";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据商户Id批量查询行业Id及名称
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelGetIndustryInfoByBatchHotelId(body, header) {
    var url = "/merchant-api/eb/hotel/getIndustryInfoByBatchHotelId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据adminId获取本商户的数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetOfficeHotelsByAdminId(query, header) {
    var url = "/merchant-api/eb/hotel/getOfficeHotelsByAdminId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取品牌分类列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetBrandCategoryList(query, header) {
    var url = "/merchant-api/eb/hotel/get_brand_category_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取当前酒店营业点
 * @param header The http request header parameters.
 */
export function getEbHotelGetCurrentHotelCounters(header) {
    var url = "/merchant-api/eb/hotel/get_current_hotel_counters";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取酒店品牌列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetHotelBrandList(query, header) {
    var url = "/merchant-api/eb/hotel/get_hotel_brand_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户所有销售渠道(不支持多种集团模式)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetMerchantAllSaleChannelInfo(query, header) {
    var url = "/merchant-api/eb/hotel/get_merchant_all_sale_channel_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店团建账户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetSecondBonusOwner(query, header) {
    var url = "/merchant-api/eb/hotel/get_second_bonus_owner";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工部门营业点信息
 * @param header The http request header parameters.
 */
export function getEbHotelGetUserDepartmentCounter(header) {
    var url = "/merchant-api/eb/hotel/get_user_department_counter";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据hotelID查询纠错信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelGetmerchantCorrectWrongRecordInfo(query, header) {
    var url = "/merchant-api/eb/hotel/getmerchantCorrectWrongRecordInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 酒店品牌列表排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelHotelBrandListSort(body, header) {
    var url = "/merchant-api/eb/hotel/hotel_brand_list_sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店商户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelInfoQuery(query, header) {
    var url = "/merchant-api/eb/hotel/info/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存酒店商户信息
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelInfoSave(query, body, header) {
    var url = "/merchant-api/eb/hotel/info/save";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 检查是否能进行纠错
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelIsCanUpdateCorrectMerchantInfoList(body, header) {
    var url = "/merchant-api/eb/hotel/is_can_update_correct_merchant_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询商户版分类列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelMerchantAppCategoryQuery(query, header) {
    var url = "/merchant-api/eb/hotel/merchant/app/category/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存商户版分类顺序
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelMerchantAppCategorySave(query, body, header) {
    var url = "/merchant-api/eb/hotel/merchant/app/category/save";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 保存品牌分类
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelSaveBrandCategory(body, header) {
    var url = "/merchant-api/eb/hotel/save_brand_category";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存酒店品牌
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelSaveHotelBrand(body, header) {
    var url = "/merchant-api/eb/hotel/save_hotel_brand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除酒店秘钥
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelSecretKeyDelete(query, header) {
    var url = "/merchant-api/eb/hotel/secret/key/delete";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 新增酒店秘钥
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelSecretKeySave(body, header) {
    var url = "/merchant-api/eb/hotel/secret/key/save";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改酒店秘钥
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelSecretKeyUpdate(body, header) {
    var url = "/merchant-api/eb/hotel/secret/key/update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置酒店团建账户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelSetSecondBonusOwner(body, header) {
    var url = "/merchant-api/eb/hotel/set_second_bonus_owner";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 创建商户声明
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementCreatStatement(body, header) {
    var url = "/merchant-api/eb/hotel/statement/creat_statement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除商户声明
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementDeleteStatement(body, header) {
    var url = "/merchant-api/eb/hotel/statement/delete_statement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过页面keys和商户id查询声明
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementGetStatementByPageKeyListAndHotelId(query, body, header) {
    var url = "/merchant-api/eb/hotel/statement/getStatementByPageKeyListAndHotelId";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 通过声明id查询商户声明详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelStatementGetStatementDetailById(query, header) {
    var url = "/merchant-api/eb/hotel/statement/getStatementDetailById";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过模板id查询商户声明模板详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelStatementGetStatementTemplateDetailById(query, header) {
    var url = "/merchant-api/eb/hotel/statement/getStatementTemplateDetailById";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户声明展示页面
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelStatementGetStatementPage(query, header) {
    var url = "/merchant-api/eb/hotel/statement/get_statement_page";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户声明模板列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementGetStatementTemplateList(body, header) {
    var url = "/merchant-api/eb/hotel/statement/get_statement_template_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户声明数据迁移
 * @param header The http request header parameters.
 */
export function postEbHotelStatementMerchantStatementTransfer(header) {
    var url = "/merchant-api/eb/hotel/statement/merchant_statement_transfer";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 页面选项
 * @param header The http request header parameters.
 */
export function getEbHotelStatementPageDisplays(header) {
    var url = "/merchant-api/eb/hotel/statement/page_displays";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 查询隐私声明
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelStatementQuery(query, header) {
    var url = "/merchant-api/eb/hotel/statement/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存隐私声明
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementSave(query, body, header) {
    var url = "/merchant-api/eb/hotel/statement/save";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 商户声明排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementSaveStatementSort(body, header) {
    var url = "/merchant-api/eb/hotel/statement/save_statement_sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户声明列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementStatementList(body, header) {
    var url = "/merchant-api/eb/hotel/statement/statement_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户声明同步门店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementSynHotel(body, header) {
    var url = "/merchant-api/eb/hotel/statement/syn_hotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新商户声明
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementUpdateStatement(body, header) {
    var url = "/merchant-api/eb/hotel/statement/update_statement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 停止或恢复展示声明
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelStatementUpdateStatementStatus(body, header) {
    var url = "/merchant-api/eb/hotel/statement/update_statement_status";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * eb纠错接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelUpdateCorrectMerchantInfoList(body, header) {
    var url = "/merchant-api/eb/hotel/update_correct_merchant_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterBatchHotelCounterInfo(body, header) {
    var url = "/merchant-api/eb/hotel_counter/batchHotelCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 分页查询营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterBatchCounterList(body, header) {
    var url = "/merchant-api/eb/hotel_counter/batch_counter_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除营业点信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelCounterDeleteCounterInfo(query, header) {
    var url = "/merchant-api/eb/hotel_counter/delete_counter_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询营业点信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelCounterGetCounterById(query, header) {
    var url = "/merchant-api/eb/hotel_counter/get_counter_by_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店营业点信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelCounterGetHotelCounters(query, header) {
    var url = "/merchant-api/eb/hotel_counter/get_hotel_counters";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 分页查询共享酒店营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterQueryShareHotelCounterInfo(body, header) {
    var url = "/merchant-api/eb/hotel_counter/queryShareHotelCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存营业点和部门关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterSaveCounterDepartmentRelation(body, header) {
    var url = "/merchant-api/eb/hotel_counter/save_counter_department_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterSaveCounterInfo(body, header) {
    var url = "/merchant-api/eb/hotel_counter/save_counter_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改营业点状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbHotelCounterUpdateCounterStatus(body, header) {
    var url = "/merchant-api/eb/hotel_counter/update_counter_status";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过商户版appId查询绑定商户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetHotelIdByShanghuAppId(query, header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_hotel_id_by_shanghu_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户版app信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetHotelShanghuAppInfo(query, header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_hotel_shanghu_app_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户版功能配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetHotelShanghuFunctionConfig(query, header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_hotel_shanghu_function_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户版所有appId
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetShanghuAppIdList(header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_shanghu_app_id_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取商户版app信息通过appId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetShanghuAppInfoByAppId(query, header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_shanghu_app_info_by_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取指定类型的所有自营销售渠道
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbHotelShanghuGetShanghuSaleChannelByAppType(query, header) {
    var url = "/merchant-api/eb/hotel_shanghu/get_shanghu_sale_channel_by_app_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 创建/修改标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLabelCreateOrUpdate(body, header) {
    var url = "/merchant-api/eb/label/create_or_update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除标签
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbLabelDelete(query, header) {
    var url = "/merchant-api/eb/label/delete";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 搜索标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbLabelSearch(body, header) {
    var url = "/merchant-api/eb/label/search";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 展示/隐藏标签
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbLabelShowOrHide(query, header) {
    var url = "/merchant-api/eb/label/show_or_hide";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * batchSaveMemberConfig
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbMemberConfigBatchSaveMemberConfig(body, header) {
    var url = "/merchant-api/eb/member_config/batch_save_member_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * getMemberConfig
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbMemberConfigGetMemberConfig(query, header) {
    var url = "/merchant-api/eb/member_config/get_member_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getMemberConfigs
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbMemberConfigGetMemberConfigs(body, header) {
    var url = "/merchant-api/eb/member_config/get_member_configs";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * saveMemberConfig
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbMemberConfigSaveMemberConfig(body, header) {
    var url = "/merchant-api/eb/member_config/save_member_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbSupplierTemplateConfigQuery(query, header) {
    var url = "/merchant-api/eb/supplier/template/config/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存酒店配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbSupplierTemplateConfigSave(body, header) {
    var url = "/merchant-api/eb/supplier/template/config/save";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 数据迁移
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postEbSupplierTemplateConfigTransfer(query, header) {
    var url = "/merchant-api/eb/supplier/template/config/transfer";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 批量保存酒店模板接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbTemplateBatchSaveTemplate(body, header) {
    var url = "/merchant-api/eb/template/batchSaveTemplate";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店当前模板接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbTemplateGetTemplate(query, header) {
    var url = "/merchant-api/eb/template/getTemplate";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过酒店ID获取当前酒店模板接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbTemplateGetTemplateByHotelId(query, header) {
    var url = "/merchant-api/eb/template/getTemplateByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存酒店模板接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbTemplateSaveTemplate(body, header) {
    var url = "/merchant-api/eb/template/saveTemplate";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * eb模板列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbTemplateTemplateList(query, header) {
    var url = "/merchant-api/eb/template/templateList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户版获取隐私协议
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbmHotelStatementGetPlatformStatement(query, header) {
    var url = "/merchant-api/ebm/hotel/statement/getPlatformStatement";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户版通过页面key和商户id查询声明
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbmHotelStatementGetStatementByPageKeyAndHotelId(query, header) {
    var url = "/merchant-api/ebm/hotel/statement/getStatementByPageKeyAndHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户版通过商户声明主键id查询图文详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbmHotelStatementGetStatementContentById(query, header) {
    var url = "/merchant-api/ebm/hotel/statement/getStatementContentById";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取可编辑的商户渠道列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getGetEditableMerchantChannelList(query, header) {
    var url = "/merchant-api/getEditableMerchantChannelList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户渠道列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getGetMerchantChannelList(query, header) {
    var url = "/merchant-api/getMerchantChannelList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取公卡渠道信息，没有就开通
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getGetMerchantPublicChannel(query, header) {
    var url = "/merchant-api/get_merchant_public_channel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询商户星级标签等基础信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelBaseQuery(query, header) {
    var url = "/merchant-api/hotel/base/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量更新商户信息
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelBatchUpdateHotelInfo(query, body, header) {
    var url = "/merchant-api/hotel/batchUpdateHotelInfo";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 批量查询酒店基础信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelBatchHotelCommonInfo(body, header) {
    var url = "/merchant-api/hotel/batch_hotel_common_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取酒店位置相关信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelBatchHotelLocationInfo(body, header) {
    var url = "/merchant-api/hotel/batch_hotel_location_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 集团酒店筛选
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelBrandHotelFilter(body, header) {
    var url = "/merchant-api/hotel/brand_hotel_filter";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 爱打折创建商户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelCreateHotelForLoveDiscount(body, header) {
    var url = "/merchant-api/hotel/createHotelForLoveDiscount";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量创建商户信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelCreateHotelInfoByHotelIdListByPost(body, header) {
    var url = "/merchant-api/hotel/createHotelInfoByHotelIdListByPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appid查询所有业务线币种信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelCurrenciesGetByAppId(query, header) {
    var url = "/merchant-api/hotel/currencies/get_by_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户id和业务线获取币种信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelCurrencyGetByBusinessType(query, header) {
    var url = "/merchant-api/hotel/currency/get_by_business_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 酒店详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDetail(query, header) {
    var url = "/merchant-api/hotel/detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店基本信息(包含城市),不限额
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelExtGetHotelBaseAndCityInfoByHotelIdList(body, header) {
    var url = "/merchant-api/hotel/ext/getHotelBaseAndCityInfoByHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询酒店扩展信息,最多500个酒店Id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelExtGetHotelExtByHotelIds(query, header) {
    var url = "/merchant-api/hotel/ext/getHotelExtByHotelIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取省市区
 * @param header The http request header parameters.
 */
export function getHotelFindArea(header) {
    var url = "/merchant-api/hotel/findArea";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取ADMINID旗下所有酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelFindHotelIdsByAdminId(query, header) {
    var url = "/merchant-api/hotel/findHotelIdsByAdminId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询所有酒店集合根据创建时间范围
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelFindHotelInfoByCreateTime(query, header) {
    var url = "/merchant-api/hotel/findHotelInfoByCreateTime";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的简单信息,只返回酒店Id和酒店名称
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelFindHotelSimpleInfo(query, header) {
    var url = "/merchant-api/hotel/findHotelSimpleInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * findShopType
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelFindShopType(query, header) {
    var url = "/merchant-api/hotel/findShopType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店电话信息 最多1000条
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelFindSimpleHotelInfoByHotelIds(body, header) {
    var url = "/merchant-api/hotel/findSimpleHotelInfoByHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据BrandId查询所有hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetAllHotelByBrandId(query, header) {
    var url = "/merchant-api/hotel/getAllHotelByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询所有酒店ID集合
 * @param header The http request header parameters.
 */
export function getHotelGetAllHotelIdList(header) {
    var url = "/merchant-api/hotel/getAllHotelIdList";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 查询brandId下所有酒店及其共享酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetAllHotelIdsByBrandId(query, header) {
    var url = "/merchant-api/hotel/getAllHotelIdsByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询同Brand下的所有hotelId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetAllHotelIdsForBrandByHotelId(query, header) {
    var url = "/merchant-api/hotel/getAllHotelIdsForBrandByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据BrandId查询brand
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetBrandByBrandId(query, header) {
    var url = "/merchant-api/hotel/getBrandByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据BrandCorpId查询BrandCorp
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetBrandCorpByBrandCorpId(query, header) {
    var url = "/merchant-api/hotel/getBrandCorpByBrandCorpId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询集团下子店所在城市
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetBrandHotelCitys(query, header) {
    var url = "/merchant-api/hotel/getBrandHotelCitys";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询其所属的集团信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetBrandListByHotelId(query, header) {
    var url = "/merchant-api/hotel/getBrandListByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 全国所有度假酒店列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHolidayHotels(query, header) {
    var url = "/merchant-api/hotel/getHolidayHotels";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询hotel的管理者（商务MM，运营MM）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelAdminRelationInfo(body, header) {
    var url = "/merchant-api/hotel/getHotelAdminRelationInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询酒店城市信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelAreaByHotelIdList(query, header) {
    var url = "/merchant-api/hotel/getHotelAreaByHotelIdList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店基本信息,不限额
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelBaseInfoByHotelIdList(body, header) {
    var url = "/merchant-api/hotel/getHotelBaseInfoByHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据BrandId查询hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelByBrandId(query, header) {
    var url = "/merchant-api/hotel/getHotelByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询Hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelByHotelId(query, header) {
    var url = "/merchant-api/hotel/getHotelByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据supplierAccountId查询Hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelBySupplierAccountId(query, header) {
    var url = "/merchant-api/hotel/getHotelBySupplierAccountId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据clientId获取商户销售关系信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelClientInfoByClientId(query, header) {
    var url = "/merchant-api/hotel/getHotelClientInfoByClientId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据HotelId和Key查询HotelConfig
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelConfigByHotelIdAndKey(body, header) {
    var url = "/merchant-api/hotel/getHotelConfigByHotelIdAndKey";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店ID和营业点名称模糊查询（自营+集团范围内）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelCounterByCounterName(query, header) {
    var url = "/merchant-api/hotel/getHotelCounterByCounterName";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID查询营业点
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelCounterByHotelId(query, header) {
    var url = "/merchant-api/hotel/getHotelCounterByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店信息,最多500个酒店Id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelInfoByHotelIdList(query, header) {
    var url = "/merchant-api/hotel/getHotelInfoByHotelIdList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店信息 最多1000条
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelInfoByHotelIdList(body, header) {
    var url = "/merchant-api/hotel/getHotelInfoByHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询酒店信息，并通过酒店名称排序
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelInfoByHotelIdListAndOrder(query, header) {
    var url = "/merchant-api/hotel/getHotelInfoByHotelIdListAndOrder";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量查询酒店信息,最多500个酒店Id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelInfoByHotelIdListByPost(body, header) {
    var url = "/merchant-api/hotel/getHotelInfoByHotelIdListByPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据brandId查询与金房卡hotelId的映射
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelIwideMappingByBrandId(query, header) {
    var url = "/merchant-api/hotel/getHotelIwideMappingByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据zkt酒店Id查询与金房卡hotelId的映射
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelIwideMappingByHotelIds(body, header) {
    var url = "/merchant-api/hotel/getHotelIwideMappingByHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据金房卡酒店Id查询与zktHotelId的映射
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postHotelGetHotelIwideMappingByIwideHotelIds(body, header) {
    var url = "/merchant-api/hotel/getHotelIwideMappingByIwideHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据金房卡酒店Id与interId查询与zktHotelId映射
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelIwideMappingByIwideHotelParam(body, header) {
    var url = "/merchant-api/hotel/getHotelIwideMappingByIwideHotelParam";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询hotel的办事处信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelOrgInfoList(body, header) {
    var url = "/merchant-api/hotel/getHotelOrgInfoList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据brandID,hotelId,hotelName查询其下酒店的ID及名称(中文/英文/其他语言)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelSimpleInfo(query, header) {
    var url = "/merchant-api/hotel/getHotelSimpleInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据集团ID和城市查询商户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelSimpleInfoByBrandIdAndCityId(query, header) {
    var url = "/merchant-api/hotel/getHotelSimpleInfoByBrandIdAndCityId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据多个(1~200)酒店ID查询其名称(中文/英文/其他语言)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelSimpleInfoList(query, header) {
    var url = "/merchant-api/hotel/getHotelSimpleInfoList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandID查询其下酒店的ID及名称(中文/英文/其他语言)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelSimpleInfoListByBrandId(query, header) {
    var url = "/merchant-api/hotel/getHotelSimpleInfoListByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据城市查询酒店列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelsByArea(body, header) {
    var url = "/merchant-api/hotel/getHotelsByArea";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店ID和名称，必须在集团下,按城市和名字检索
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetHotelsByBrandIdAndCity(body, header) {
    var url = "/merchant-api/hotel/getHotelsByBrandIdAndCity";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询商户及其关联的信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetMerchantAndRelatedInfo(body, header) {
    var url = "/merchant-api/hotel/getMerchantAndRelatedInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据AdminId查询有权限的酒店（新+老）办事处
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetMisreportOfficeDepartmentList(query, header) {
    var url = "/merchant-api/hotel/getMisreportOfficeDepartmentList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据指定坐标和酒店集合获取附近酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetNearHotelsByPointAndHotels(body, header) {
    var url = "/merchant-api/hotel/getNearHotelsByPointAndHotels";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店和地区获取附近共享酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetNearShareHotelsByHotelAndArea(body, header) {
    var url = "/merchant-api/hotel/getNearShareHotelsByHotelAndArea";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据AdminId查询有权限的酒店办事处
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetOfficeHotelIdList(query, header) {
    var url = "/merchant-api/hotel/getOfficeHotelIdList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询PC官网Hotel信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetPcHotelByHotelId(query, header) {
    var url = "/merchant-api/hotel/getPcHotelByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和appId查询销售关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetSaleRelation(body, header) {
    var url = "/merchant-api/hotel/getSaleRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据HotelId查询SupplierAccount
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetSupplierAccountByHotelId(query, header) {
    var url = "/merchant-api/hotel/getSupplierAccountByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据supplierAccountId查询SupplierAccount
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetSupplierAccountBySupplierAccountId(body, header) {
    var url = "/merchant-api/hotel/getSupplierAccountBySupplierAccountId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据HotelId查询SupplierAccountId等信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetSupplierAccountSimpleInfoByHotelId(query, header) {
    var url = "/merchant-api/hotel/getSupplierAccountSimpleInfoByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID查询自营公众号过期时间
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetWxAppExpireInfo(query, header) {
    var url = "/merchant-api/hotel/getWxAppExpireInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店所有团建账户信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetAllSecondBonusOwners(query, header) {
    var url = "/merchant-api/hotel/get_all_second_bonus_owners";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店设施信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelEquipmentInfo(query, header) {
    var url = "/merchant-api/hotel/get_hotel_equipment_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户视频号小店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetHotelWechatStoreConfig(query, header) {
    var url = "/merchant-api/hotel/get_hotel_wechat_store_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取位置区域和品牌数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelGetLocationAndBrand(body, header) {
    var url = "/merchant-api/hotel/get_location_and_brand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取酒店团建账户信息,有userId优先查对应部门的团建账户，否则查酒店的团建账户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelGetSecondBonusOwner(query, header) {
    var url = "/merchant-api/hotel/get_second_bonus_owner";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量更新商户的集团ID
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelHotelChangeBrand(body, header) {
    var url = "/merchant-api/hotel/hotelChangeBrand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新商户的图片地址
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelImageUpdate(body, header) {
    var url = "/merchant-api/hotel/image/update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取酒店已绑定标签接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelLabelRelationBatchBindLabelByHotelIds(body, header) {
    var url = "/merchant-api/hotel/label/relation/batch_bind_label_by_hotel_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 酒店与标签绑定接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelLabelRelationBind(body, header) {
    var url = "/merchant-api/hotel/label/relation/bind";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取酒店已绑定标签接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelLabelRelationGetBindLabelByHotel(query, header) {
    var url = "/merchant-api/hotel/label/relation/get_bind_label_by_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取酒店已绑定标签信息接口(只返回聚合后的标签基本信息)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelLabelRelationGetBindLabelByHotels(body, header) {
    var url = "/merchant-api/hotel/label/relation/get_bind_label_by_hotels";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 酒店与标签排序接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelLabelRelationSort(body, header) {
    var url = "/merchant-api/hotel/label/relation/sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 酒店与标签解绑接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelLabelRelationUnbind(body, header) {
    var url = "/merchant-api/hotel/label/relation/unbind";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户信息列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelList(body, header) {
    var url = "/merchant-api/hotel/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获得指定掩码配置值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelMaskGetMaskItemConfigValue(query, header) {
    var url = "/merchant-api/hotel/mask/get_mask_item_config_value";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询商户版分类列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelMerchantAppCategoryQuery(query, header) {
    var url = "/merchant-api/hotel/merchant/app/category/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id/酒店名称查询所属集团下的所有酒店以及酒店所在地区信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetBrandHotelAndAreaInfo(query, header) {
    var url = "/merchant-api/hotel/other/getBrandHotelAndAreaInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据部门查询营业点
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetCounterByDepartment(query, header) {
    var url = "/merchant-api/hotel/other/getCounterByDepartment";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的营业点部门信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetCounterDepartmentInfo(query, header) {
    var url = "/merchant-api/hotel/other/getCounterDepartmentInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据营业点ID查询详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetCounterDetailByCounterId(query, header) {
    var url = "/merchant-api/hotel/other/getCounterDetailByCounterId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询多个hotel的营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelOtherGetCounterInfoByHotelIds(body, header) {
    var url = "/merchant-api/hotel/other/getCounterInfoByHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询多个hotel的营业点信息及部门名称
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelOtherGetCounterInfoWithDeptNameByHotelIds(body, header) {
    var url = "/merchant-api/hotel/other/getCounterInfoWithDeptNameByHotelIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店部门信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetDepartmentInfo(query, header) {
    var url = "/merchant-api/hotel/other/getDepartmentInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商家的负责BD及MM
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetHotelBdAndMm(query, header) {
    var url = "/merchant-api/hotel/other/getHotelBDAndMM";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商家的负责BD及TL
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetHotelBdAndTlInfo(query, header) {
    var url = "/merchant-api/hotel/other/getHotelBDAndTLInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店星级列表
 * @param header The http request header parameters.
 */
export function getHotelOtherGetHotelStarAllInfo(header) {
    var url = "/merchant-api/hotel/other/getHotelStarAllInfo";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取酒店星级根据酒店类型
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetHotelStarByHotelType(query, header) {
    var url = "/merchant-api/hotel/other/getHotelStarByHotelType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店星级列表(CRM酒店拜访使用)
 * @param header The http request header parameters.
 */
export function getHotelOtherGetHotelStarLevelInfo(header) {
    var url = "/merchant-api/hotel/other/getHotelStarLevelInfo";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 分页查询营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postHotelOtherGetPageCounterInfo(body, header) {
    var url = "/merchant-api/hotel/other/getPageCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询员工所属的营业点权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetUserCounterRights(query, header) {
    var url = "/merchant-api/hotel/other/getUserCounterRights";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id查询标签所属酒店id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelOtherGetTagRelationHotelId(query, header) {
    var url = "/merchant-api/hotel/other/get_tag_relation_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 历史营业点关联所有部门
 * @param header The http request header parameters.
 */
export function postHotelOtherInitCounterInfo(header) {
    var url = "/merchant-api/hotel/other/initCounterInfo";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 修改营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postHotelOtherModifyCounterInfo(body, header) {
    var url = "/merchant-api/hotel/other/modifyCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postHotelOtherRemoveCounterInfo(body, header) {
    var url = "/merchant-api/hotel/other/removeCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postHotelOtherSaveCounterInfo(body, header) {
    var url = "/merchant-api/hotel/other/saveCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * POST方式批量查询酒店城市信息(与getHotelAreaByHotelIdList接口实现相同)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelQueryHotelAreaByHotelIdList(body, header) {
    var url = "/merchant-api/hotel/queryHotelAreaByHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询酒店基础信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelQueryHotelBasicInfo(body, header) {
    var url = "/merchant-api/hotel/queryHotelBasicInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据关键词获取酒店联想数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelQueryHotelRecommendInfoByKeyword(body, header) {
    var url = "/merchant-api/hotel/query_hotel_recommend_info_by_keyword";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * removeCache
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelRemoveCache(query, header) {
    var url = "/merchant-api/hotel/removeCache";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 接口创建及修改商户，不需要审核，不校验档案信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelSave(body, header) {
    var url = "/merchant-api/hotel/save";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存与金房卡门店的mapping
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelSaveIwideMapping(body, header) {
    var url = "/merchant-api/hotel/saveIwideMapping";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 检索酒店,优先展示已合作的
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelSearchCooperatedHotels(query, header) {
    var url = "/merchant-api/hotel/searchCooperatedHotels";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店秘钥
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelSecretKeyGetByHotelAndSceneAndType(body, header) {
    var url = "/merchant-api/hotel/secret/key/get_by_hotel_and_scene_and_type";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过页面key和商户id查询声明
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelStatementGetStatementByPageKeyAndHotelId(query, header) {
    var url = "/merchant-api/hotel/statement/getStatementByPageKeyAndHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过商户声明主键id查询图文详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelStatementGetStatementContentById(query, header) {
    var url = "/merchant-api/hotel/statement/getStatementContentById";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询隐私声明
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelStatementRoomQuery(query, header) {
    var url = "/merchant-api/hotel/statement/room/query";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步商户信息Job
 * @param header The http request header parameters.
 */
export function getHotelSyncMerchantInfoJob(header) {
    var url = "/merchant-api/hotel/sync_merchant_info_job";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * fixHotelShare
 * @param header The http request header parameters.
 */
export function getHotelToolsFixHotelShare(header) {
    var url = "/merchant-api/hotel/tools/fixHotelShare";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 计算两个酒店距离，并保存到表中
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelToolsHotelMappingCalHotelMappingDistance(query, header) {
    var url = "/merchant-api/hotel/tools/hotel/mapping/calHotelMappingDistance";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 导入外部酒店与zkt酒店文件
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postHotelToolsHotelMappingImportFile(query, header) {
    var url = "/merchant-api/hotel/tools/hotel/mapping/import_file";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 进行酒店名和距离的匹配，并保存到表里
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelToolsHotelMappingMappingResult(query, header) {
    var url = "/merchant-api/hotel/tools/hotel/mapping/mapping_result";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 更新酒店的经纬度信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelToolsHotelMappingUpdateLocation(query, header) {
    var url = "/merchant-api/hotel/tools/hotel/mapping/update_location";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 外部酒店与zkt酒店匹配
 * @param header The http request header parameters.
 */
export function postHotelToolsHotelMappingUploadFile(header) {
    var url = "/merchant-api/hotel/tools/hotel/mapping/upload_file";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 酒店价格比价触发执行
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelToolsHotelPriceExecute(query, header) {
    var url = "/merchant-api/hotel/tools/hotel/price/execute";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 导入外部酒店价格
 * @param header The http request header parameters.
 */
export function postHotelToolsHotelPriceImportFile(header) {
    var url = "/merchant-api/hotel/tools/hotel/price/import_file";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 修改商户合作状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelUpdateCooperationStatus(query, header) {
    var url = "/merchant-api/hotel/updateCooperationStatus";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量更新商户信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelUpdateHotelInfoByHotelIdListByPost(body, header) {
    var url = "/merchant-api/hotel/updateHotelInfoByHotelIdListByPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步酒店服务状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelUpdateServiceStatus(body, header) {
    var url = "/merchant-api/hotel/update_service_status";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelCounterBatchHotelCounterInfo(body, header) {
    var url = "/merchant-api/hotel_counter/batchHotelCounterInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询部门关联营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelCounterGetDepartmentCounters(body, header) {
    var url = "/merchant-api/hotel_counter/get_department_counters";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据id查询营业点信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelCounterGetHotelCounterById(query, header) {
    var url = "/merchant-api/hotel_counter/get_hotel_counter_by_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据id批量查询营业点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelCounterGetHotelCounterByIds(body, header) {
    var url = "/merchant-api/hotel_counter/get_hotel_counter_by_ids";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询全部行业列表
 * @param header The http request header parameters.
 */
export function getIndustryGetIndustryAll(header) {
    var url = "/merchant-api/industry/getIndustryAll";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据业务类型ID批量查询行业信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postIndustryGetIndustryInfoByTypeIds(body, header) {
    var url = "/merchant-api/industry/getIndustryInfoByTypeIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据行业ID和业务线获取产品分类信息接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getIndustryGetTypeProductByIndustryId(query, header) {
    var url = "/merchant-api/industry/getTypeProductByIndustryId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appid查询所有业务线币种信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getInnerMerchantCurrencyGetByAppid(query, header) {
    var url = "/merchant-api/inner/merchant/currency/get_by_appid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户id和业务线获取币种信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getInnerMerchantCurrencyGetByBusinessType(query, header) {
    var url = "/merchant-api/inner/merchant/currency/get_by_business_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 清除迁移appid的缓存
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postInnerMigratingMigratingAppidAddCheck(body, header) {
    var url = "/merchant-api/inner/migrating/migrating_appid/add/check";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 清除迁移appid的缓存
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postInnerMigratingMigratingAppidCacheDel(body, header) {
    var url = "/merchant-api/inner/migrating/migrating_appid/cache/del";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 将酒店配置项转成同步gpt的实体
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobConvertHotelConfigItemIntoGptParam(body, header) {
    var url = "/merchant-api/job/convert_hotel_config_item_into_gpt_param";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 初始化分销酒店信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobInitDistributeJob(body, header) {
    var url = "/merchant-api/job/init_distribute_job";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 初始化分销酒店百度经纬度信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobInitDistributeJobBaiduLngLat(body, header) {
    var url = "/merchant-api/job/init_distribute_job_baidu_lng_lat";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户币种数据修复
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobMerchantCurrencyDataFix(query, header) {
    var url = "/merchant-api/job/merchant_currency/data/fix";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取交通信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobQueryTrafficInfo(body, header) {
    var url = "/merchant-api/job/query_traffic_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 重置酒店位置信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobResetHotelLocationInfo(body, header) {
    var url = "/merchant-api/job/reset_hotel_location_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步商圈信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobSyncBusinessAreaInfo(query, header) {
    var url = "/merchant-api/job/sync_business_area_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步酒店团建账户信息至新表
 * @param header The http request header parameters.
 */
export function getJobSyncHotelSecondBonusOwnerData(header) {
    var url = "/merchant-api/job/sync_hotel_second_bonus_owner_data";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 更新wxapp信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postJobWxappSync(query, header) {
    var url = "/merchant-api/job/wxapp/sync";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 公众号到期早上提醒 8:00
 * @param header The http request header parameters.
 */
export function getJobWxappExpireNotify(header) {
    var url = "/merchant-api/job/wxapp_expire_notify";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 公众号到期晚上提醒 20:00
 * @param header The http request header parameters.
 */
export function getJobWxappExpireRenotify(header) {
    var url = "/merchant-api/job/wxapp_expire_renotify";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 直连同步标签接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postLabelDirectPush(body, header) {
    var url = "/merchant-api/label/direct_push";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过场景获取标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postLabelFindByBusinessScene(body, header) {
    var url = "/merchant-api/label/find_by_business_scene";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据标签标识获取标签id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function getLabelGetLabelIdByCode(query, header) {
    var url = "/merchant-api/label/get_label_id_by_code";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据标签标识获取标签信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getLabelGetLabelInfoByCode(query, header) {
    var url = "/merchant-api/label/get_label_info_by_code";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取标签详情信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postLabelGetLebelInfo(body, header) {
    var url = "/merchant-api/label/get_lebel_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 酒店品牌及业单位主字典列表
 * @param header The http request header parameters.
 */
export function getMisAdminHotelBrandSimpleInfoList(header) {
    var url = "/merchant-api/mis/admin/hotelBrandSimpleInfoList";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 业主列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisAdminHotelProprietorList(query, header) {
    var url = "/merchant-api/mis/admin/hotelProprietorList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存业主数据及负责的员工
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisAdminSaveHotelProprietor(body, header) {
    var url = "/merchant-api/mis/admin/saveHotelProprietor";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取集团
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisBrandBrand(query, header) {
    var url = "/merchant-api/mis/brand/brand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除集团
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisBrandDelete(query, header) {
    var url = "/merchant-api/mis/brand/delete";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询集团列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandList(body, header) {
    var url = "/merchant-api/mis/brand/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询集团操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandLogs(body, header) {
    var url = "/merchant-api/mis/brand/logs";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandMerchants(body, header) {
    var url = "/merchant-api/mis/brand/merchants";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加新的集团
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandSave(body, header) {
    var url = "/merchant-api/mis/brand/save";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新集团
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandUpdate(body, header) {
    var url = "/merchant-api/mis/brand/update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户检查
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisBrandValidate(body, header) {
    var url = "/merchant-api/mis/brand/validate";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过hotelId获取分销和三方基础信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisDistributeHotelGetDistributeAndTripartiteBasicsWithHotelId(body, header) {
    var url = "/merchant-api/mis/distribute/hotel/get_distribute_and_tripartite_basics_with_hotelId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新分销酒店信息接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisDistributeHotelUpdateDistributeInfo(body, header) {
    var url = "/merchant-api/mis/distribute/hotel/update_distribute_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 审批酒店信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelApprovalActionsApprove(body, header) {
    var url = "/merchant-api/mis/hotel/approval/actionsApprove";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取当前登录人已提交的审批数量
 * @param header The http request header parameters.
 */
export function postMisHotelApprovalGetApproveCountByAdminId(header) {
    var url = "/merchant-api/mis/hotel/approval/getApproveCountByAdminId";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 获取酒店审批详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelApprovalInfo(query, header) {
    var url = "/merchant-api/mis/hotel/approval/info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店审批列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelApprovalList(body, header) {
    var url = "/merchant-api/mis/hotel/approval/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除审批记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelApprovalLogicDelete(body, header) {
    var url = "/merchant-api/mis/hotel/approval/logicDelete";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 绑定的抖音商户id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelBindDouyinMerchantId(query, header) {
    var url = "/merchant-api/mis/hotel/bind_douyin_merchant_id";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 绑定或解绑集团时核验商户门票资产
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelCheckHotelPassInfo(query, header) {
    var url = "/merchant-api/mis/hotel/check_hotel_pass_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 创建商户声明模板
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelCreatStatementTemplate(body, header) {
    var url = "/merchant-api/mis/hotel/creat_statement_template";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * mis删除商户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelDelete(body, header) {
    var url = "/merchant-api/mis/hotel/delete";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除商户声明模板
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelDeleteStatementTemplate(body, header) {
    var url = "/merchant-api/mis/hotel/delete_statement_template";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * Mis商户详情页
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelDetail(query, header) {
    var url = "/merchant-api/mis/hotel/detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据主店ID查询集团简单信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetBrandInfoByOwnByHotelId(query, header) {
    var url = "/merchant-api/mis/hotel/getBrandInfoByOwnByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据办事处查询酒店数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelGetEndHotelsByOrgOfficeId(body, header) {
    var url = "/merchant-api/mis/hotel/getEndHotelsByOrgOfficeId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据hotelId查询Hotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetHotelByHotelId(query, header) {
    var url = "/merchant-api/mis/hotel/getHotelByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询酒店相关信息-集团配置自定义项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelGetSpecialHotelByBrandId(body, header) {
    var url = "/merchant-api/mis/hotel/getSpecialHotelByBrandId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过模板id查询商户声明模板详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetStatementTemplateDetailById(query, header) {
    var url = "/merchant-api/mis/hotel/getStatementTemplateDetailById";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户所有销售渠道(不支持多种集团模式)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetAllMerchantSaleChannel(query, header) {
    var url = "/merchant-api/mis/hotel/get_all_merchant_sale_channel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取该酒店绑定的抖音商户id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetDouyinMerchantId(query, header) {
    var url = "/merchant-api/mis/hotel/get_douyin_merchant_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户以及集团信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetHotelAndBrandInfo(query, header) {
    var url = "/merchant-api/mis/hotel/get_hotel_and_brand_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店获取小程序信息（优先自营）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelGetWxaInfoByHotel(query, header) {
    var url = "/merchant-api/mis/hotel/get_wxa_info_by_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * mis商户列表,会进行数据权限校验
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelList(body, header) {
    var url = "/merchant-api/mis/hotel/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * mis列表获取授权状态状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelListStatus(query, header) {
    var url = "/merchant-api/mis/hotel/listStatus";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获得掩码配置项信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelMaskGetMerchantMaskItemConfig(query, header) {
    var url = "/merchant-api/mis/hotel/mask/get_merchant_mask_item_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量保存商户掩码配置项
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelMaskSaveMerchantMaskItemConfig(body, header) {
    var url = "/merchant-api/mis/hotel/mask/save_merchant_mask_item_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * MIS创建及修改商户(带审批功能)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelSaveByApproval(body, header) {
    var url = "/merchant-api/mis/hotel/saveByApproval";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置商户服务状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelSetHotelServiceStatus(body, header) {
    var url = "/merchant-api/mis/hotel/setHotelServiceStatus";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户声明模板列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelStatementTemplateList(body, header) {
    var url = "/merchant-api/mis/hotel/statement_template_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取MIS预售券产品统计筛选条件
 * @param adminId 获取MIS预售券产品统计筛选条件
 * @param header The http request header parameters.
 */
export function getMisHotelTicketProductInfoConditionAdminId(adminId, header) {
    var url = "/merchant-api/mis/hotel/ticket_product_info_condition/" + adminId;
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 解绑抖音商户id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelUnBindDouyinMerchantId(query, header) {
    var url = "/merchant-api/mis/hotel/unBind_douyin_merchant_id";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 根据纠错数据更新商户信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelUpdateCorrectMerchantInfo(body, header) {
    var url = "/merchant-api/mis/hotel/updateCorrectMerchantInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新商户声明模板
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelUpdateStatementTemplate(body, header) {
    var url = "/merchant-api/mis/hotel/update_statement_template";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 一键切换小程序配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelConfigChangeAppletPromotionConfig(query, header) {
    var url = "/merchant-api/mis/hotel_config/change_applet_promotion_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取中央预订配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelConfigGetCentralBookConfig(query, header) {
    var url = "/merchant-api/mis/hotel_config/get_central_book_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取配置默认值
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelConfigGetConfigItemDefaultValue(query, header) {
    var url = "/merchant-api/mis/hotel_config/get_config_item_default_value";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 新增掩码配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelConfigInsertMaskItem(body, header) {
    var url = "/merchant-api/mis/hotel_config/insert_mask_item";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存中央预订配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelConfigSaveCentralBookConfig(body, header) {
    var url = "/merchant-api/mis/hotel_config/save_central_book_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改配置默认值
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelConfigUpdateConfigItemValue(body, header) {
    var url = "/merchant-api/mis/hotel_config/update_config_item_value";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 创建商户互动游戏配置信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelThirdConfigCreatHotelEqxiuConfig(body, header) {
    var url = "/merchant-api/mis/hotel_third_config/creat_hotel_eqxiu_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除商户视频号小店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelThirdConfigDeleteHotelWechatStoreConfig(query, header) {
    var url = "/merchant-api/mis/hotel_third_config/delete_hotel_wechat_store_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户互动游戏配置信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelThirdConfigGetHotelEqxiuConfigInfo(query, header) {
    var url = "/merchant-api/mis/hotel_third_config/get_hotel_eqxiu_config_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户互动游戏配置信息集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelThirdConfigGetHotelEqxiuConfigInfoList(query, header) {
    var url = "/merchant-api/mis/hotel_third_config/get_hotel_eqxiu_config_info_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户视频号小店配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHotelThirdConfigGetHotelWechatStoreConfig(query, header) {
    var url = "/merchant-api/mis/hotel_third_config/get_hotel_wechat_store_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存商户视频号小店配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotelThirdConfigSaveHotelWechatStoreConfig(body, header) {
    var url = "/merchant-api/mis/hotel_third_config/save_hotel_wechat_store_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询办事处Id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisOfficeGetOfficeBatchByOfficeId(body, header) {
    var url = "/merchant-api/mis/office/getOfficeBatchByOfficeId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询办事处IdList
 * @param header The http request header parameters.
 */
export function getMisOfficeGetOfficeListForBrandProprietorList(header) {
    var url = "/merchant-api/mis/office/getOfficeListForBrandProprietorList";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取商户风险默认配置项接口
 * @param header The http request header parameters.
 */
export function postMisRiskGetDefaultConfig(header) {
    var url = "/merchant-api/mis/risk/get_default_config";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 商户风险配置列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRiskList(body, header) {
    var url = "/merchant-api/mis/risk/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 操作商户风险接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRiskOperate(body, header) {
    var url = "/merchant-api/mis/risk/operate";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户安全防护明细列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRiskProtectionList(body, header) {
    var url = "/merchant-api/mis/risk/protection/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 商户风险配置接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisRiskSaveOrUpdate(body, header) {
    var url = "/merchant-api/mis/risk/save_or_update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 开通渠道
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOpenChannel(body, header) {
    var url = "/merchant-api/openChannel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据brandId查询风险配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getQrSubscribeGetQrSubscribeConfigByBrand(query, header) {
    var url = "/merchant-api/qr_subscribe/get_qr_subscribe_config_by_brand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询风险配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getRiskGetRiskConfigByBrand(query, header) {
    var url = "/merchant-api/risk/get_risk_config_by_brand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 酒店场景是否需要做风险识别
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getRiskNeedVerifyRiskByHotel(query, header) {
    var url = "/merchant-api/risk/need_verify_risk_by_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户风险拦截记录日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRiskSubHotelRiskQuota(body, header) {
    var url = "/merchant-api/risk/sub_hotel_risk_quota";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改公众号名称
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationAppNameUpdate(body, header) {
    var url = "/merchant-api/sale/relation/appName/update";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 校验所有的appId是否同属于一个商户.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationBeyondSameMerchant(body, header) {
    var url = "/merchant-api/sale/relation/beyondSameMerchant";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 校验当前newAppId与oldAppId在指定时间点是否同属于一个商户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationBeyondSameMerchantWithTime(body, header) {
    var url = "/merchant-api/sale/relation/beyondSameMerchantWithTime";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 校验销售渠道集团id是否与管理集团列表中任何一个存在集团关系，存在返回true，不存在返回false
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationCheckBrandRelation(body, header) {
    var url = "/merchant-api/sale/relation/checkBrandRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店Id和AppType获取Client，优先自营，然后集团
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationClientGetByHotelIdAndAppType(query, header) {
    var url = "/merchant-api/sale/relation/client/get_by_hotel_id_and_app_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 清除appId和openId的映射
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationDelHotelPromotionChannelRelation(query, header) {
    var url = "/merchant-api/sale/relation/delHotelPromotionChannelRelation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 解绑新销售关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationDoUnbind(body, header) {
    var url = "/merchant-api/sale/relation/doUnbind";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appId列表查询appInfo.
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationEnableCrossMerchant(query, header) {
    var url = "/merchant-api/sale/relation/enable_cross_merchant";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询所关联集团（自营+集团）下的所有酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllRelationHotelByHotelId(query, header) {
    var url = "/merchant-api/sale/relation/getAllRelationHotelByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId和appType查询appInfo
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppInfoByAppIdAndAppType(query, header) {
    var url = "/merchant-api/sale/relation/getAppInfoByAppIdAndAppType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId列表查询appInfo.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationGetAppInfoByAppIds(body, header) {
    var url = "/merchant-api/sale/relation/getAppInfoByAppIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据appId列表查询appInfo
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationGetAppInfoByAppIds2(body, header) {
    var url = "/merchant-api/sale/relation/getAppInfoByAppIds2";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据brandId和appType获取渠道信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppInfoByBrandId(query, header) {
    var url = "/merchant-api/sale/relation/getAppInfoByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId和appTypeList获取渠道信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppInfoByBrandIdAndAppTypes(query, header) {
    var url = "/merchant-api/sale/relation/getAppInfoByBrandIdAndAppTypes";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId获取所有自营渠道信息列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppInfosByBrandId(query, header) {
    var url = "/merchant-api/sale/relation/getAppInfosByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店Id和AppType查询Client
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetClientByHotelIdAndAppType(query, header) {
    var url = "/merchant-api/sale/relation/getClientByHotelIdAndAppType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店Id和AppType查询Client,返回一个且优先自营主店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetClientByHotelIdAndAppTypeV2(query, header) {
    var url = "/merchant-api/sale/relation/getClientByHotelIdAndAppTypeV2";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户id,查询开通了微信公众号的集团id（支持多种模式）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postSaleRelationGetMultiModeSelfBrandByMerchantIdsAndWxChannel(body, header) {
    var url = "/merchant-api/sale/relation/getMultiModeSelfBrandByMerchantIdsAndWxChannel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店Id和AppType拿到Client
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetOrCreateClientByHotelIdAndAppType(query, header) {
    var url = "/merchant-api/sale/relation/getOrCreateClientByHotelIdAndAppType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店下的销售渠道 1-自营，2-集团 [迁移自ticket.bmw.php.get_point_relation方法,给预售券详情页勾选参与积分使用]
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetPointRelation(query, header) {
    var url = "/merchant-api/sale/relation/getPointRelation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店ID(多个),APP_ID查询relation关系, 如果没有销售关系，则saleRelationId为0
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationGetRelationByHotelIdsAndAppId(body, header) {
    var url = "/merchant-api/sale/relation/getRelationByHotelIdsAndAppId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量获取大于某id的一批saleclient
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetSaleClientGreaterThanSaleClientId(query, header) {
    var url = "/merchant-api/sale/relation/getSaleClientGreaterThanSaleClientId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据AppId获取销售终端信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetSaleClientInfoByAppId(query, header) {
    var url = "/merchant-api/sale/relation/getSaleClientInfoByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商户id,批量查询自营集团，如果没有自营则不进行返回
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationGetSelfBrandByMerchantIds(body, header) {
    var url = "/merchant-api/sale/relation/getSelfBrandByMerchantIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据商户id,查询开通了微信公众号的自营渠道对应的集团id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationGetSelfBrandByMerchantIdsAndWxChannel(body, header) {
    var url = "/merchant-api/sale/relation/getSelfBrandByMerchantIdsAndWxChannel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据brandId查询所有的销售关系酒店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllHotelByBrandId(query, header) {
    var url = "/merchant-api/sale/relation/get_all_hotel_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId查询所有销售关系酒店id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllHotelIdByAppId(query, header) {
    var url = "/merchant-api/sale/relation/get_all_hotel_id_by_app_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据brandId查询所有销售关系酒店id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllHotelIdByBrandId(query, header) {
    var url = "/merchant-api/sale/relation/get_all_hotel_id_by_brand_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户管理下所有销售渠道(不支持多种集团模式)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllMerchantSaleChannel(query, header) {
    var url = "/merchant-api/sale/relation/get_all_merchant_sale_channel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有公众号AppId
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllPublicAppId(header) {
    var url = "/merchant-api/sale/relation/get_all_public_app_id";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取指定类型的所有自营销售渠道
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAllSaleChannelByAppType(query, header) {
    var url = "/merchant-api/sale/relation/get_all_sale_channel_by_app_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * (支持多种集团模式)根据hotelId查询appId(优先自营，然后按照绑定顺序获取)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppIdByHotelId(query, header) {
    var url = "/merchant-api/sale/relation/get_app_id_by_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 按app类型分页查询
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetAppIdListByTypeAndPage(query, header) {
    var url = "/merchant-api/sale/relation/get_app_id_list_by_type_and_page";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店管理和销售关系id列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetHotelManageAndSaleList(query, header) {
    var url = "/merchant-api/sale/relation/get_hotel_manage_and_sale_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户销售渠道(支持多种集团模式)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationGetMerchantSaleChannel(query, header) {
    var url = "/merchant-api/sale/relation/get_merchant_sale_channel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId查询需要关注的公众号AppId（小生活需求）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationQueryFollowAppId(query, header) {
    var url = "/merchant-api/sale/relation/queryFollowAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appid获取所属酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationQueryHotelIdByAppId(query, header) {
    var url = "/merchant-api/sale/relation/queryHotelIdByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的集团关系下有关联的集团id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationQueryHotelRelatedByOwnerHotelId(query, header) {
    var url = "/merchant-api/sale/relation/queryHotelRelatedByOwnerHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的集团关系和共享关系, 参数hotelIdList, containsDeletedBrand 表示包含已经删除的
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationQueryHotelRelatedByToHotelIdList(query, body, header) {
    var url = "/merchant-api/sale/relation/queryHotelRelatedByToHotelIdList";
    return config.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
/**
 * 获取推广appId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationQueryPromotionAppId(query, header) {
    var url = "/merchant-api/sale/relation/queryPromotionAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店的共享关系, 参数hotelIdList
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationQueryShareHotelIdByToHotelIdList(body, header) {
    var url = "/merchant-api/sale/relation/queryShareHotelIdByToHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店的共享关系酒店Id及名称, 参数hotelIdList
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationQueryShareHotelSimpleInfoByToHotelIdList(body, header) {
    var url = "/merchant-api/sale/relation/queryShareHotelSimpleInfoByToHotelIdList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询商户的自营销售终端
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationQuerySupplierSaleClientInfo(query, header) {
    var url = "/merchant-api/sale/relation/querySupplierSaleClientInfo";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 仅提供推荐人保护期使用，通过集团关系、共享关系查询关联酒店id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationQueryUserRecommendProtectionHotelRelation(body, header) {
    var url = "/merchant-api/sale/relation/queryUserRecommendProtectionHotelRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存appId和openId的映射
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationSaveHotelPromotionChannelRelation(body, header) {
    var url = "/merchant-api/sale/relation/saveHotelPromotionChannelRelation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询自营酒店APPID
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationSelectAppIdsByHotelIds(query, header) {
    var url = "/merchant-api/sale/relation/selectAppIdsByHotelIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询自营酒店APPID
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSaleRelationSelectAppIdsByHotelIdsByPost(body, header) {
    var url = "/merchant-api/sale/relation/selectAppIdsByHotelIdsByPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询酒店的集团关系下有关联的集团id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationSelectBrandHotelListByBrandId(query, header) {
    var url = "/merchant-api/sale/relation/selectBrandHotelListByBrandId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询商户第一次绑定的集团的主店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSaleRelationSelectBrandOwnd(query, header) {
    var url = "/merchant-api/sale/relation/selectBrandOwnd";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据商家ID及业务线查询运营商关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSupplierBasicserviceRelaCommonRela(query, header) {
    var url = "/merchant-api/supplier/basicservice/rela/common/rela";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据appId及业务类型查询运营商信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSupplierBasicserviceRelaCommonRelaByAppId(query, header) {
    var url = "/merchant-api/supplier/basicservice/rela/common/relaByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取所有运营商
 * @param header The http request header parameters.
 */
export function getSupplierBasicserviceRelaIsp(header) {
    var url = "/merchant-api/supplier/basicservice/rela/isp";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 权益卡绑定运营商
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postSupplierBasicserviceRelaPluscardIsp(body, header) {
    var url = "/merchant-api/supplier/basicservice/rela/pluscard/isp";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 权益卡运营商关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSupplierBasicserviceRelaPluscardRela(query, header) {
    var url = "/merchant-api/supplier/basicservice/rela/pluscard/rela";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通过appId与hotelId获取子店移动端风格相关配置接口（子店部分配置读取主店）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getTemplateGetSupplierTemplateByAppIdAndHotelId(query, header) {
    var url = "/merchant-api/template/getSupplierTemplateByAppIdAndHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店当前模板接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getTemplateGetTemplate(query, header) {
    var url = "/merchant-api/template/getTemplate";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询AppId对应酒店当前模板接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getTemplateGetTemplateByAppId(query, header) {
    var url = "/merchant-api/template/getTemplateByAppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 开通酒店短信渠道
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getTemplateOpenHotelSmsPromotionChannel(query, header) {
    var url = "/merchant-api/template/openHotelSmsPromotionChannel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * eb模板列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getTemplateTemplateList(query, header) {
    var url = "/merchant-api/template/templateList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 分析微信菜单变更记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoAnalyzeMenu(query, header) {
    var url = "/merchant-api/wx/app/info/analyze/menu";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 授权通知
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postWxAppInfoAuthorizationNotice(body, header) {
    var url = "/merchant-api/wx/app/info/authorization/notice";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量处理已授权数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postWxAppInfoBatchProcessing(body, header) {
    var url = "/merchant-api/wx/app/info/batch/processing";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 批量查询appId主体
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postWxAppInfoBatchQueryAppInfo(body, header) {
    var url = "/merchant-api/wx/app/info/batch/query/app/info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询并修改appid主体信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoQueryAndUpdateAppidSubject(query, header) {
    var url = "/merchant-api/wx/app/info/query/and/update/appid/subject";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询appid主体信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoQueryAppidSubject(query, header) {
    var url = "/merchant-api/wx/app/info/query/appid/subject";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取模板信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoWechatGetNotifyTypeById(query, header) {
    var url = "/merchant-api/wx/app/info/wechat/get_notify_type_by_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取业务线使用的模板列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoWechatTemplateUsedForBiz(query, header) {
    var url = "/merchant-api/wx/app/info/wechat/template/usedForBiz";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通知公众号过期,点击8点再提醒
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getWxAppInfoWxworkBtn(query, header) {
    var url = "/merchant-api/wx/app/info/wxwork/btn";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
//#endregion
